import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home/index.vue";

Vue.use(Router);

const basetitle =
  " - Value Public Chain Based on Distributed Storage Technology";

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: `Lambda Storage Network Official Website${basetitle}`
      }
    },

    //lambda兑换
    {
      path: "/exchange",
      name: "exchange",
      meta: {
        title: ``
      },
      redirect: "/exchange/toLambda1",
      component: () => import("./views/Exchange/index.vue"),
      children: [
        {
          path: "toLambda1",
          name: "toLambda1",
          component: () => import("./views/Exchange/toLambda1.vue")
        },
        {
          path: "toLambda2",
          name: "toLambda2",
          component: () => import("./views/Exchange/toLambda2.vue")
        }
      ]
    },

    // 关于Lambda
    {
      path: "/about",
      name: "about",
      meta: {
        title: `关于Lambda ${basetitle}`
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About/index.vue")
    },

    {
      path: "/airdrop",
      name: "airdrop",
      meta: {
        title: `Airdrop ${basetitle}`
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Airdrop/index.vue")
    },

    // 开发者
    {
      path: "/developer",
      name: "developer",
      meta: {
        title: `开发者 ${basetitle}`
      },
      component: () =>
        import(
          /* webpackChunkName: "developer" */ "./views/Developer/index.vue"
        )
    },

    {
      path: "/LambdaDAO",
      name: "LambdaDAO",
      meta: {
        title: `LambdaDAO ${basetitle}`
      },
      component: () =>
        import(
          /* webpackChunkName: "LambdaDAO" */ "./views/LambdaDAO/index.vue"
        )
    },

    {
      path: "/news",
      name: "news",
      meta: {
        title: `新闻动态 ${basetitle}`
      },
      component: () =>
        import(/* webpackChunkName: "news" */ "./views/Notice/News.vue")
    },
    {
      path: "/*",
      name: "404",
      component: () =>
        import(/* webpackChunkName: "404" */ "./views/404/index.vue")
    },
    // 公告栏
    // {
    //   path: "/notice",
    //   name: "notice",
    //   meta: {
    //     title: `公告栏 ${basetitle}`
    //   },
    //   component: () =>
    //     import(/* webpackChunkName: "notice" */ "./views/Notice/Notice.vue")
    // },

    // {
    //   path: "/help",
    //   name: "help",
    //   meta: {
    //     title: `帮助中心 ${basetitle}`
    //   },
    //   component: () =>
    //     import(/* webpackChunkName: "help" */ "./views/Notice/Help.vue")
    // },

    // {
    //   path: "/notice",
    //   name: "notice",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/Notice/index.vue")
    // },
    // {
    //   path: "/Developer",
    //   name: "DeveloperCenter",
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/Developer/index.vue")
    // },

    // 组件测试

    {
      path: "/component",
      name: "component",
      meta: {
        title: `测试自定组件 ${basetitle}`
      },
      component: () =>
        import(
          /* webpackChunkName: "components" */ "./views/Components/index.vue"
        )
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

const notchangeList = ["home"];

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  if (!notchangeList.includes(to.name)) {
    to.meta.changeNav = true;
  }
  next();
});

export default router;
